import { useCallback, useState } from 'react';
import AWS from 'aws-sdk';
import { downloadURI } from './archivos';

const { 
  REACT_APP_AWS_BUCKET_NAME,
  REACT_APP_AWS_REGION,
  REACT_APP_AWS_ACCESS_KEY,
  REACT_APP_AWS_SECRET_KEY
 } = process.env;

 AWS.config.update({
  accessKeyId: REACT_APP_AWS_ACCESS_KEY,
  secretAccessKey: REACT_APP_AWS_SECRET_KEY,
});

const autoEvaluacionBucket = new AWS.S3({
  params: { Bucket: REACT_APP_AWS_BUCKET_NAME },
  region: REACT_APP_AWS_REGION
})

export const useSubirArchivo = () => {
  const [progreso, setProgreso] = useState(0);
  const [error, setError] = useState(null);

  /**
   * @description Uploads a file into S3 account
   * @param {File} file
   * @param {string} folder
   */
  const uploadFile = useCallback(async (file, folder='') => {
    if (!file) {
      const mensajeDeError = 'Archivo no suministrado';
      console.error(mensajeDeError);
      setError(mensajeDeError)
      return { error: { message: mensajeDeError} }
    }

    const params = {
      ACL: 'public-read',
      Body: file,
      Bucket: REACT_APP_AWS_BUCKET_NAME,
      Key: [folder, file.name].join('/')
    }
    return autoEvaluacionBucket.putObject(params)
      .on('httpUploadProgress',
        ({ loaded, total }) => setProgreso(Math.round((loaded / total) * 100)))
      .send(setError)
  }, [])
  
  return [uploadFile, { progreso, error }]
}

export const useDescargarArchivo = ({setErrors}) => {
  const [estaDescargando, setEstaDescargando] = useState(false);

  /**
   * @description Downloads a file from S3 account
   * @param {string} key
   */
  const descargarArchivo = useCallback(async (key) => {
    try {
      if (!key) {
        throw new Error('Archivo no suministrado')
      }
      setEstaDescargando(true)
      const res = await fetch(`https://${REACT_APP_AWS_BUCKET_NAME}.s3.amazonaws.com/${key}`)
      const blob = await res.blob()
      const url = window.URL.createObjectURL(blob)
      downloadURI(url, blob, key)
      return { success: true }
    } catch (error) {
      setErrors({ 'Error': [error.message ?? error] })
    } finally {
      setEstaDescargando(false)
    }
    
  }, [setErrors])

  return [descargarArchivo, { estaDescargando }]
}